export default __webpack_public_path__ + "static/media/rare8.96711813.gif";